import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

// ⚠ Warning: the condition is very important because it is dangerous to make available these objects globally in production.
if (process.env.NODE_ENV === 'development') {
	window.vue = Vue
	window.store = store
  window.router = router
  }

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
